
define("collaboration/bundle", function(){});
